import extend from './extend';

export enum ProjectStatus {
  Inactive = 1,
  Active = 2,
  Archived = 3,
  Draft = 4,
}

export enum ProjectType {
  Survey = 1,
  Call = 2,
  SurveyCall = 3,
}

export const ProjectTypeMap = extend(new Map([
  [ProjectType.Call, { name: 'Interviews' }],
  [ProjectType.Survey, { name: 'Online Survey' }],
  [ProjectType.SurveyCall, { name: 'Screener + Interviews' }],
]));

export enum ProjectSubtype {
  OpportunityAssessment = 1,
  ConceptTesting = 2,
  MessageTesting = 3,
  PositioningTesting = 4,
  VisualAidTesting = 5,
  PatientJourney = 6,
  /* JourneyTesting = 7, */
  Other = 8,
  Segmentation = 9,
  DriversAndBarriers = 10,
  DemandAssessment = 11,
  CurrentLandscape = 12,
  /* AdverseEventsManagement = 13, */
}

export enum AudienceType {
  Payer = 1,
  Patient = 2,
  HealthcareProfessional = 3,
  HealthcarePractitioner = 4,
  Other = 5,
}

export enum ProjectGoalType {
  Call = 1,
  Survey = 2,
}

export * from './project.action';